const pageNameKey = "otaBackupProcessInProgress";

export const otaBackupProcessInProgressEn = {
  [pageNameKey]: {
    baseTitle: "Backup Creation is in Progress.",
    operationIdTemplate: " ({operationId})",
    description: "Please wait while the backup is being created.",
    showDetailsButtonText: "Show Details",
  },
};

export const otaBackupProcessInProgressPtBr = {
  [pageNameKey]: {
    baseTitle: "A criação do backup está em andamento.",
    operationIdTemplate: " ({operationId})",
    description: "Aguarde enquanto o backup está sendo criado.",
    showDetailsButtonText: "Mostrar detalhes",
  },
};

export const otaBackupProcessInProgressDe = {
  [pageNameKey]: {
    baseTitle: "Die Backup-Erstellung läuft.",
    operationIdTemplate: " ({operationId})",
    description: "Bitte warten Sie, während das Backup erstellt wird.",
    showDetailsButtonText: "Details anzeigen",
  },
};

export const otaBackupProcessInProgressZhHans = {
  [pageNameKey]: {
    baseTitle: "备份创建正在进行中。",
    operationIdTemplate: "（{operationId}）",
    description: "请稍候，正在创建备份。",
    showDetailsButtonText: "显示详情",
  },
};

export const otaBackupProcessInProgressIt = {
  [pageNameKey]: {
    baseTitle: "Creazione backup in corso.",
    operationIdTemplate: " ({operationId})",
    description: "Attendere mentre il backup viene creato.",
    showDetailsButtonText: "Mostra dettagli",
  },
};

export const otaBackupProcessInProgressEs = {
  [pageNameKey]: {
    baseTitle: "La creación del respaldo está en curso.",
    operationIdTemplate: " ({operationId})",
    description: "Espere mientras se crea el respaldo.",
    showDetailsButtonText: "Mostrar detalles",
  },
};

export const otaBackupProcessInProgressNl = {
  [pageNameKey]: {
    baseTitle: "Back-up maken wordt uitgevoerd.",
    operationIdTemplate: " ({operationId})",
    description: "Wacht terwijl de back-up wordt gemaakt.",
    showDetailsButtonText: "Details tonen",
  },
};

export const otaBackupProcessInProgressTr = {
  [pageNameKey]: {
    baseTitle: "Yedek Oluşturma Devam Ediyor.",
    operationIdTemplate: "({operationId})",
    description: "Yedekleme oluşturulurken lütfen bekleyin.",
    showDetailsButtonText: "Ayrıntıları Göster",
  },
};
